import { render, staticRenderFns } from "./bindDialog.vue?vue&type=template&id=f10a06cc&scoped=true&"
import script from "./bindDialog.vue?vue&type=script&lang=ts&"
export * from "./bindDialog.vue?vue&type=script&lang=ts&"
import style0 from "./bindDialog.vue?vue&type=style&index=0&id=f10a06cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10a06cc",
  null
  
)

export default component.exports